<template>
  <div class="recaptcha-wrapper">
    <div ref="recaptchaContainer" class="g-recaptcha"></div>
    <span class="message-holder" v-show="showError">
      <slot name="error">Please prove you are not a bot</slot>
    </span>
  </div>
</template>

<script>
import { RECAPTCHA_SITE_KEY } from "../../config/_entrypoint";

export default {
  name: "GoogleRecaptcha",

  props: {
    action: {
      type: String,
      default: "signup"
    },
    showError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      siteKey: RECAPTCHA_SITE_KEY,
      widgetId: null
    };
  },

  mounted() {
    this.renderRecaptcha();
  },

  beforeDestroy() {
    // Clean up global callbacks
    if (this._callbackName) {
      delete window[this._callbackName];
    }
    if (this._expiredCallbackName) {
      delete window[this._expiredCallbackName];
    }
  },

  methods: {
    renderRecaptcha() {
      this.$nextTick(() => {
        if (window.hasOwnProperty('grecaptcha') && window.grecaptcha.hasOwnProperty('enterprise')) {
          window.grecaptcha.enterprise.ready(() => {
            console.log('next tick')
            this.doRender();
          });
        } else {
          // Wait for grecaptcha to load if not yet available
          const checkInterval = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.enterprise) {
              window.grecaptcha.enterprise.ready(() => {
                console.log('delay')
                clearInterval(checkInterval);
                this.doRender();
              });
            }
          }, 100);

          // Clear interval after 10 seconds to prevent infinite loop
          setTimeout(() => clearInterval(checkInterval), 10000);
        }
      });
    },

    doRender() {
      const container = this.$refs.recaptchaContainer;
      if (!container || container.childElementCount > 0) {
        return; // Already rendered or container not available
      }

      // Create unique callback names for this instance
      this._callbackName = `recaptchaVerified_${this._uid}`;
      this._expiredCallbackName = `recaptchaExpired_${this._uid}`;

      // Set up global callbacks
      window[this._callbackName] = this.onVerified;
      window[this._expiredCallbackName] = this.onExpired;

      try {
        this.widgetId = window.grecaptcha.enterprise.render(container, {
          sitekey: this.siteKey,
          callback: this._callbackName,
          "expired-callback": this._expiredCallbackName,
          action: this.action
        });
      } catch (e) {
        console.error("Failed to render reCAPTCHA:", e);
      }
    },

    onVerified(response) {
      this.$emit("verified", response);
    },

    onExpired() {
      this.$emit("expired");
    },

    reset() {
      if (window.grecaptcha && window.grecaptcha.enterprise && this.widgetId !== null) {
        try {
          window.grecaptcha.enterprise.reset(this.widgetId);
        } catch (e) {
          console.error("Failed to reset reCAPTCHA:", e);
        }
      }
      this.$emit("reset");
    }
  }
};
</script>

<style lang="scss" scoped>
.recaptcha-wrapper {
  display: inline-block;
}
</style>
